module.exports = __webpack_public_path__ + "img/weight.03fd93a2.svg";